export function sniffVisitCardImageMime(base64OrDataUrl) {
  const raw = String(base64OrDataUrl || "").replace(/^data:[^;]+;base64,/, "");
  if (raw.startsWith("iVBORw0KGgo")) return "image/png";
  if (raw.startsWith("/9j/")) return "image/jpeg";
  if (raw.startsWith("R0lGOD")) return "image/gif";
  if (raw.startsWith("UklGR")) return "image/webp";
  return "";
}

export function normalizeVisitCardPhoto(dataUrl, fallbackMime = "image/jpeg") {
  const raw = String(dataUrl || "").replace(/^data:[^;]+;base64,/, "");
  const declared =
    /^data:([^;]+);base64,/i.exec(String(dataUrl || ""))?.[1] || "";
  const photoMime =
    sniffVisitCardImageMime(raw) || declared || fallbackMime || "image/jpeg";
  return {
    photoBase64: raw ? `data:${photoMime};base64,${raw}` : "",
    photoMime,
  };
}
